






































































































































































// vue
import Vue, { PropOptions } from 'vue';
import NOC from '@/class/common/const';
import * as NOCArray from '@/personal/array';
import {fncChangeStringToJPFormat} from '@/class/common/moment';

// api
import API from '@/api/common';
import * as models from '@/class/models/views/setting/users';
import { IAccount } from '@/class/models/views/account';

// validation
import * as validation from '@/personal/validation';

// components
import {IOption} from '@/components/util/SelectBox.vue';
import VariableInput, {IVariableInput, INPUT_TYPE} from '@/components/util/VariableInput.vue';
import SearchBox from '@/components/util/SearchBox.vue';

// parts
import RelationList, {IRelationData} from '@/parts/setting/users/RelationList.vue';
import UserSideModal, {IUserSideModalData} from '@/parts/setting/users/UserSideModal.vue';
import GroupSideModal from '@/parts/setting/users/GroupSideModal.vue';

// datepicker
import DatePicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale';

// local const
const SIDE = {
  DEVICE: 'device',
  MODERATOR: 'moderator',
  GROUP: 'group',
};

export default Vue.extend({
  name: 'Users',
  components: { SearchBox, RelationList, VariableInput, UserSideModal, DatePicker, GroupSideModal },
  props: {
    confirmDialog: Function,
    ownerFlag : Boolean,
  },
  data() {
    return {
      accountData: {} as IAccount,
      usersList: [] as models.IUser[],
      devicesList:  [] as models.IDevice[],
      moderatorsList:  [] as models.IModerator[],
      groupList: [] as models.IGroup[],
      groupUsedList: [] as models.IGroupUsed[],
      selectUser: {} as models.IUser,
      selectUserDevicesList: [] as models.IDevice[],
      selectUserModeratorsList: [] as models.IModerator[],
      selectUserGroupList: [] as models.IGroup[],
      selectUserGroupUsedList: [] as models.IGroupUsed[],
      editUser: {} as models.IUser,
      editUserDevicesList: [] as models.IDevice[],
      editUserModeratorsList: [] as models.IModerator[],
      editUserGroupList: [] as models.IGroup[],
      editUserGroupUsedList: [] as models.IGroupUsed[],
      sideTitle: '',
      sideModal: '',
      items: [
        {key: 'name', name: '氏名' },
        {key: 'genderText', name: '性別' },
        {key: 'kana', name: 'カナ' },
        {key: 'workstyleText', name: '就業形態'},
        {key: 'mail', name: 'メールアドレス' },
        {key: 'roleText', name: '権限' },
        {key: 'birthday', name: '生年月日' },
        {key: 'jobText', name: '職業' },
        {key: 'flextimeText', name: 'フレックスタイム' },
      ],
      optionsRole: NOCArray.ROLE,
      optionsWorkstyle: [NOC.SELECT.FIRST],
      searchSideList: '',
      mode: '',
      editItems: [
        {key: 'sei', name: '氏名', type: INPUT_TYPE.TEXT, required: true, error: '', class: 'col-3', max: 40},
        {key: 'mei', name: '', type: INPUT_TYPE.TEXT, required: true, error: '', class: 'col-3', max: 40},
        {key: 'gender', name: '性別', type: INPUT_TYPE.SELECT, required: false, error: '', class: 'col-6', options: NOCArray.GENDER},
        {key: 'seiKana', name: 'カナ', type: INPUT_TYPE.TEXT, required: true, error: '', class: 'col-3', checks: [validation.CHECK_TYPE.KANA], max: 40},
        {key: 'meiKana', name: '', type: INPUT_TYPE.TEXT, required: true, error: '', class: 'col-3', checks: [validation.CHECK_TYPE.KANA], max: 40},
        {key: 'workstyleID', name: '就業形態', type: INPUT_TYPE.SELECT, required: true, error: '', class: 'col-6', options: [NOC.SELECT.FIRST]},
        {key: 'mail', name: 'メールアドレス', type: INPUT_TYPE.TEXT, required: false, error: '', class: 'col-6', checks: [validation.CHECK_TYPE.EMAIL], max: 40},
        {key: 'role', name: '権限', type: INPUT_TYPE.SELECT, required: true, error: '', class: 'col-6', options: [NOC.SELECT.FIRST]},
        {key: 'birthday', name: '生年月日', type: INPUT_TYPE.DATE, required: false, error: '', class: 'col-6', checks: [validation.CHECK_TYPE.DATE]},
        {key: 'jobID', name: '職種', type: INPUT_TYPE.SELECT, required: true, error: '', class: 'col-6', options: NOC.JOB.JOBArray},
        {key: 'flextime', name: 'フレックスタイム', type: 'checkbox', required: false, error: '', class: 'col-6', options: [{text: 'あり', value: 1}] as models.ISelectOption[]},
      ] as IVariableInput[],
      DatePickerDate: 'yyyy/MM/dd',
      ja,
    };
  },
  directives: {
    DatePicker,
  },
  watch: {
    'editUser.role'(to) {
      if (to === NOC.SETTING.ROLE.VALUE.GENERAL) {
        this.editItems[6].required = false;
      } else if (to === NOC.SETTING.ROLE.VALUE.MANAGER || to === NOC.SETTING.ROLE.VALUE.ADMIN ) {
        this.editItems[6].required = true;
      }
    },
  },
  computed: {
    MODE_NORMAL(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NORMAL);
    },
    MODE_SELECT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.SELECT);
    },
    MODE_EDIT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT);
    },
    MODE_NEW(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NEW);
    },
    MODE_CHARGE(): boolean {
      return this.checkMode(NOC.SETTING.MODE.CHARGE);
    },
    // 計算値　ユーザ画面表示要に変換値
    DISP_SELECT_USER() {
      let dispSelectUser = {} as models.IUser;
      // console.log(this.selectUser.workstyleID);
      dispSelectUser = JSON.parse(JSON.stringify(this.selectUser));
      // 表示用にデータを変換
      dispSelectUser.roleText = NOCArray.getOptionsText(NOCArray.ROLE, dispSelectUser.role);
      dispSelectUser.genderText = NOCArray.getOptionsText(NOCArray.GENDER, this.selectUser.gender);
      if (this.selectUser.birthday) {
        dispSelectUser.birthday = fncChangeStringToJPFormat(this.selectUser.birthday);
      }
      if (this.selectUser.workstyleID) {
        dispSelectUser.workstyleText
          = NOCArray.getOptionsText(this.optionsWorkstyle, this.selectUser.workstyleID);
      }
      dispSelectUser.jobText = NOCArray.getOptionsText(NOC.JOB.JOBArray, this.selectUser.jobID);
      dispSelectUser.flextimeText = this.selectUser.flextime ? 'あり' : 'なし';
      return dispSelectUser;
    },
    // 計算値　関連デバイス表示配列
    DISP_DEVICES_LIST(): IRelationData[] {
      const list = this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW) ?
        this.editUserDevicesList : this.selectUserDevicesList;
      return list.map((v) => ({id: v.deviceID, contents: [v.account, v.name]}));
    },
    // 計算値　関連管理者画面表示配列
    DISP_MODERATORS_LIST(): IRelationData[] {
      const list = this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW) ?
        this.editUserModeratorsList : this.selectUserModeratorsList;
      return list.map((v) => {
        const moderator = this.getModeratorUser(v);
        return {id: v.manageID, contents: [moderator.name, moderator.mail]};
      });
    },
    // 計算値　関連管理者画面表示配列
    DISP_GROUPS_LIST(): IRelationData[] {
      const grouplist = this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW) ?
        this.editUserGroupList : this.selectUserGroupList;
      const groupUsedlist = this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW) ?
        this.editUserGroupUsedList : this.selectUserGroupUsedList;
      return groupUsedlist
        .filter((gu) => (gu.userID === this.selectUser.userID))
        .map((gu) => {
          const targetGroup = grouplist.filter((g) => (gu.groupID === g.groupID));
          return {id: gu.groupID, contents: [targetGroup.length > 0 ? targetGroup[0].name : '']};
        });
    },
    // 計算値　サイドモーダル表示項目配列
    SIDE_MODAL_LIST(): IUserSideModalData[] {
      // todo
      let returnArray;
      if (this.sideModal === SIDE.DEVICE) {
        // 比較用の配列を作成
        const check = this.editUserDevicesList.map((v: models.IDevice) => (v.deviceID));
        // 未選択デバイスかつ編集中以外の項目を表示
        returnArray = this.devicesList
          .filter((v: models.IDevice) => (v.userID === 0 && ! check.includes(v.deviceID)))
          .map((v: models.IDevice) => ({texts: [v.name, v.account], value: v.deviceID}));
      } else {
        // 比較用の配列を作成
        const check = this.editUserModeratorsList.map((v: models.IModerator) => (v.manageID));
        // 一般権限以外かつ未選択の項目を表示

        returnArray = this.usersList
          .filter((v: models.IUser) => (v.role !== NOC.SETTING.ROLE.VALUE.GENERAL && ! check.includes(v.userID)))
          .map((v: models.IUser) => ({texts: [v.name, v.mail], value: v.userID}));
      }
      return returnArray;
    },
    SIDE_LIST(): any[] {
      let returnArray = this.usersList;
      if (this.searchSideList.length > 0 ) {
         returnArray = this.usersList.filter((v: models.IUser) => (v.name.indexOf(this.searchSideList) >= 0));
      }
      return returnArray;
    },
  },
  // 画面表示時処理
  async mounted() {
    this.mode = NOC.SETTING.MODE.CHARGE;
    const api = new API();
    const res = await api.get<models.VUsers>('users');
    if (res.result) {
      this.groupList = res.data.groups;
      this.groupUsedList = res.data.groupUseds;
      this.usersList = res.data.users;
      this.mode = NOC.SETTING.MODE.NORMAL;
      this.groupList = res.data.groups;
      this.groupUsedList = res.data.groupUseds;
      if (this.$props.ownerFlag) {
        this.devicesList = res.data.devices;
        this.moderatorsList = res.data.moderators;
        if (res.data.optionsWorkstyle.length > 0) {
          this.optionsWorkstyle = res.data.optionsWorkstyle;
          this.editItems[5].options = this.optionsWorkstyle;
        }
        // 再度データ再取得を非同期でかける
        this.reGet();
      }
    } else {
      this.$emit('change', NOC.APP.MODE.LOGIN);
    }
    this.$emit('pushPath', this.$route.path);
  },
  methods: {
    async reGet() {
      const api = new API();
      const res = await api.get<models.VUsers>('users/back');
      this.usersList = res.data.users;
      if (res.data.optionsWorkstyle.length > 0) {
        this.optionsWorkstyle = res.data.optionsWorkstyle;
        this.editItems[5].options = this.optionsWorkstyle;
      }
      this.devicesList = res.data.devices;
      this.moderatorsList = res.data.moderators;
    },
    async onClickResend() {
      if (!await this.confirmDialog('招待メールを再送しますか？')) {
        return;
      }
      const api = new API();
      const res = await api.get<{}>('users/resend', {targetID: this.selectUser.userID});
      if (res.result) {
        this.onClickCancel();
        this.$emit('info', '再送しました。');
      } else {
        this.$emit('info', '再送できませんでした。');
      }
    },
    // モード判定
    checkMode(mode: string) {
      return this.mode === mode;
    },
    // サイドバー項目選択処理
    async onSelectSideList(user: models.IUser) {
      if (this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW)) {
        return;
      }
      this.selectUser = user;
      this.selectUserDevicesList
        = this.devicesList.filter((v: models.IDevice) => (v.userID === user.userID));
      this.selectUserModeratorsList
        = this.moderatorsList.filter((v: models.IModerator) => (v.generalID === user.userID));
      this.selectUserGroupList = this.groupList;
      this.selectUserGroupUsedList = this.groupUsedList;
      this.mode = NOC.SETTING.MODE.SELECT;
    },
    // サイドバークラス項目処理
    classSideListActiveData(user: models.IUser) {
      return {
        active : this.selectUser.userID === user.userID,
      };
    },
    // 新規ボタン押下時処理
    onClickNew() {
      this.selectUser = new models.CUser();
      this.editUser = new models.CUser();
      this.editUserDevicesList = [] as models.IDevice[];
      this.editUserModeratorsList = [] as models.IModerator[];
      this.editUserGroupList = this.groupList;
      this.editUserGroupUsedList = this.groupUsedList;
      this.editItems[7].options = this.setOptionsRole(this.selectUser.role);
      this.mode = NOC.SETTING.MODE.NEW;
    },
    // 編集ボタン押下時処理
    onClickEdit() {
      this.editUser = JSON.parse(JSON.stringify(this.selectUser));
      this.editUserDevicesList = JSON.parse(JSON.stringify(this.selectUserDevicesList));
      this.editUserModeratorsList = JSON.parse(JSON.stringify(this.selectUserModeratorsList));
      this.editItems[7].options = this.setOptionsRole(this.selectUser.role);
      this.editUserGroupList = this.groupList;
      this.editUserGroupUsedList = this.groupUsedList;
      // this.editItems[4].disabled = true;
      // roleに応じての処理
      if (this.editUser.role === NOC.SETTING.ROLE.VALUE.ADMIN) {
        this.editItems[7].disabled = true;
        this.editItems[6].disabled = true;
      }
      this.mode = NOC.SETTING.MODE.EDIT;
    },
    // キャンセルボタン押下時処理
    onClickCancel() {
      this.sideModal = '';
      this.mode = NOC.SETTING.MODE.NORMAL;
      this.selectUser = {} as models.IUser;
      this.selectUserModeratorsList = [];
      this.selectUserDevicesList = [];
      this.editUser = {} as models.IUser;
      this.editUserDevicesList = [];
      this.editUserModeratorsList = [];
      this.editItems[7].disabled = false;
      this.editItems[6].disabled = false;
    },
    // 登録ボタン押下時処理
    async onClickRegist() {

      // validation
      if (validation.checkValues(this.editUser, this.editItems)) {
        return false;
      }
      // 相関validation
      if (this.selectUser.role === NOC.SETTING.ROLE.VALUE.MANAGER && this.editUser.role === NOC.SETTING.ROLE.VALUE.GENERAL) {
        if (!await this.confirmDialog('対象ユーザーがログインできなくなります。\nよろしいでしょうか？')) {
          return;
        }
      }
      if (this.selectUser.role === NOC.SETTING.ROLE.VALUE.MANAGER && this.editUser.role === NOC.SETTING.ROLE.VALUE.MANAGER) {
        if (this.selectUser.mail !== this.editUser.mail ) {
          if (!await this.confirmDialog('編集データのメールアドレスが変更されています。\n編集ユーザのログイン情報が初期化されますがよろしいでしょうか？')) {
            return;
          }
        }
      }

      // 登録数を調整
      if (this.usersList.length >= 200) {
        if (!this.accountData.contract) {
          // accountDataを取得していなければ通信
          const apiAccount = new API();
          const resAccount = await apiAccount.get<IAccount>('account');
          if (resAccount.result) {
            this.accountData = resAccount.data;
          }
        }
        // TRIALの申し込みなしは上限200人、
        // TRIALの申込済みとREGIST, DELAYの場合上限なし
        if (this.accountData.contract &&
          this.accountData.contract === NOC.CONTRACT.TRIAL &&
          this.accountData.quit === 1) {
          // this.$emit('info', '登録できません。お問い合わせからご連絡をお願いいたします。');
          this.$emit('info', 'お試しプランでは200名まで登録可能です。200名を超えて登録するには有料プランへのご登録をお願いいたします。');
          return;
        }
      }

      // 値を設定
      const requestData: models.VEditUser = {
        user: this.editUser,
        deviceIDs: this.editUserDevicesList.map((v: models.IDevice) => (v.deviceID)),
        manageUserIDs: this.editUserModeratorsList.map((v: models.IModerator) => (v.manageID)),
        group: JSON.stringify(this.groupList) === JSON.stringify(this.editUserGroupList) ? [] : this.editUserGroupList,
        groupUsedIDs: this.editUserGroupUsedList,
      };
      const api = new API();
      let res;

      if (this.$props.ownerFlag) {
        if (this.checkMode(NOC.SETTING.MODE.NEW)) {
          // 新規登録
          res = await api.post<models.VEditUser, models.VUsers>('users/new', requestData);
        } else {
          // 更新
          res = await api.put<models.VEditUser, models.VUsers>('users/edit', requestData);
        }
      } else {
        res = await api.post<models.VEditUser, models.VUsers>('users/group/edit', requestData);
      }

      if (res.result) {
        this.usersList = res.data.users;
        if (this.$props.ownerFlag) {
          this.devicesList = res.data.devices;
          this.moderatorsList = res.data.moderators;
        }
        this.groupList = res.data.groups;
        this.groupUsedList = res.data.groupUseds;
        this.onClickCancel();
      } else {
        this.$emit('info', '登録できませんでした。');
      }
    },
    // ユーザー削除処理
    async onClickDelete() {
      // console.log(this.selectUser.userID);
      if (await this.confirmDialog('選択中のユーザーを削除します、よろしいでしょうか？')) {
        // デバイスと管理者に関連付けがある場合削除しない
        if (this.selectUserDevicesList.length > 0) {
          this.$emit('info', 'デバイス上に関連があるため削除できません。');
          return;
        }

        if (this.selectUserModeratorsList.length > 0) {
          this.$emit('info', '管理者情報に関連があるため削除できません。');
          return;
        }
        // todo:ユーザが他と関連付けがあることによる削除不可は別途対応
        const api = new API();
        const res = await api.delete<models.VUsers>('users/delete', {deleteID: this.selectUser.userID});
        if (res.result) {
          this.usersList = res.data.users;
          this.devicesList = res.data.devices;
          this.moderatorsList = res.data.moderators;
          this.groupList = res.data.groups;
          this.groupUsedList = res.data.groupUseds;
          this.onClickCancel();
          this.$emit('info', '削除しました。');
        } else {
          this.$emit('info', '削除できませんでした。');
        }
      }
    },
    // 編集時処理 デバイス関連付け用サイドモーダル表示
    onClickAddDevice() {
      this.sideTitle = 'コンピュータを選択する';
      this.sideModal = SIDE.DEVICE;
    },
    // 編集時処理 管理者関連付け用サイドモーダル表示
    onClickAddModerator() {
      this.sideTitle = '管理者を選択する';
      this.sideModal = SIDE.MODERATOR;
    },
    // 編集時処理 グループ関連付け用サイドモーダル表示
    onClickAddGroup() {
      this.sideTitle = 'グループを選択する';
      this.sideModal = SIDE.GROUP;
    },
    // 編集時サイドモーダル追加時処理 サイドモーダル選択項目を編集項目に追加
    onClickAddSide(list: number[]) {
      // console.log(list);
      if (this.sideModal === SIDE.DEVICE) {
        // デバイスリストより選択された項目を追加
        this.editUserDevicesList = this.editUserDevicesList
          .concat( this.devicesList
          .filter((v: models.IDevice) => (v.userID === 0 && list.includes(v.deviceID))));
        // console.log(this.editUserDevicesList);
      } else {
        // ID追加
        this.editUserModeratorsList = this.editUserModeratorsList
          .concat(list.map((v: number) => ({generalID: this.editUser.userID, manageID: v}as models.IModerator)));
      }
      this.onClickCloseSideModal();
    },
    // 編集時グループ追加時処理 グループ選択項目を編集項目に追加
    async onClickEditGroup( value: {groupList: models.IGroup[], groupUsedList: models.IGroupUsed[]}) {
      this.editUserGroupList = value.groupList;
      this.editUserGroupUsedList
        = this.editUserGroupUsedList
          .filter((v) => (v.userID !== this.selectUser.userID)).concat(value.groupUsedList);
      // console.log('this editUserGroupUsedList', this.editUserGroupUsedList);
      this.onClickCloseSideModal();
    },
    // デバイス関連付け削除処理
    onClickDeleteEditDevice(value: number) {
      this.editUserDevicesList = this.editUserDevicesList
        .filter((v: models.IDevice) => (v.deviceID !== value));
      this.onClickCloseSideModal();
    },
    // 編集時処理 管理者関連付け削除処理
    onClickDeleteEditModerator(value: number) {
      this.editUserModeratorsList = this.editUserModeratorsList
        .filter((v: models.IModerator) => (v.manageID !== value));
      this.onClickCloseSideModal();
    },
    // サイドモーダルを閉じる処理
    onClickCloseSideModal() {
      this.sideModal = '';
    },
    // ユーザの権限を追加
    getUserStringRole(role: number): string {
      return NOCArray.getOptionsText(NOCArray.ROLE, role);
    },
    // 関連付けデータの情報取得
    getModeratorUser(moderator: models.IModerator) {
      const targetUser
        = this.usersList.filter((v: models.IUser) => (v.userID === moderator.manageID));
      return { name: targetUser[0].name, mail: targetUser[0].mail };
    },
    setOptionsRole(role: number): IOption[] {
      // 値コピー
      const options = JSON.parse(JSON.stringify(NOCArray.ROLE));
      // 選択肢として不要なデータを削除
      options.shift();
      if (role === 1) {
        options.shift();
        options.shift();
      } else {
        options.pop();
      }
      return options;
    },
  },
});
